// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2WXAR","header":"Messages_header__2mSES"};